<script setup lang="ts">
import { ref } from 'vue';
import { UploadIcon } from '@heroicons/vue/outline';

const active = ref(false);
</script>

<template>
  <label
    for="dropzoneFile"
    :class="[active ? 'border-neutral-400 dark:border-neutral-500' : 'border-neutral-300 dark:border-neutral-600']"
    class="relative block w-full cursor-pointer rounded-lg border-2 border-dashed p-12 text-center hover:border-neutral-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:border-neutral-500"
    @dragenter.prevent="active = true"
    @dragleave.prevent="active = false"
    @dragover.prevent
    @drop.prevent="active = false"
  >
    <UploadIcon
      :class="[active ? 'text-neutral-500 dark:text-neutral-400' : 'text-neutral-400 dark:text-neutral-500']"
      class="pointer-events-none mx-auto h-12 w-12"
    />
    <span class="pointer-events-none mt-2 block text-sm font-medium text-neutral-900 dark:text-neutral-50"
      >Drop your offer file, or click to select a file</span
    >
    <input id="dropzoneFile" type="file" class="hidden" accept=".offer" />
  </label>
</template>
